/**
 * Korean (ko) — 한국어 번역 파일
 * All keys use flat namespace.key format
 */
export const ko: Record<string, string> = {
  // ── Menu Scenes ──────────────────────────────────────────
  'menu.play_game': '게임 시작',
  'menu.version': 'v0.1.0 - PHASER MIGRATION',
  'menu.back_to_menu': '메뉴로 돌아가기',

  // ── Options ──────────────────────────────────────────────
  'options.title': '설정',
  'options.graphics': '그래픽',
  'options.audio': '오디오',
  'options.gameplay': '게임플레이',
  'options.language': '언어',
  'options.resolution': '해상도:',
  'options.quality': '품질:',
  'options.fullscreen': '전체 화면',
  'options.autosave': '자동 저장',
  'options.show_tooltips': '툴팁 표시',
  'options.master_volume': '마스터 볼륨',
  'options.music_volume': '음악 볼륨',
  'options.sfx_volume': '효과음 볼륨',
  'options.difficulty': '난이도:',
  'options.select_language': '언어 선택',

  // ── Login ────────────────────────────────────────────────
  'login.brand_crimson': 'CRIMSON',
  'login.brand_mandate': 'MANDATE',
  'login.tagline': '채굴\u2022교역\u2022정복\u2022USDC 획득',
  'login.version': 'CRIMSON MANDATE v0.1.0',
  'login.enter_email': '이메일 입력',
  'login.email_placeholder': 'commander@fleet.com',
  'login.enter_password': '비밀번호 입력',
  'login.password_placeholder': '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
  'login.remember_me': '로그인 유지',
  'login.conquer_galaxy': '은하를 정복하라',
  'login.connecting': '연결 중...',
  'login.forgot_password': '비밀번호 찾기',
  'login.create_account': '계정 생성 >',
  'login.password_reset_soon': '비밀번호 재설정 기능 준비 중',
  'login.shop_banner': '함선을 구매하려면 계정이 필요합니다. 로그인하거나 아래에서 계정을 생성하세요.',
  'login.enter_email_password': '이메일과 비밀번호를 입력하세요',
  'login.server_unavailable': '서버에 연결할 수 없습니다. 나중에 다시 시도하세요.',
  'login.login_failed': '로그인 실패',
  'login.connection_failed': '연결 실패',
  'login.unknown_error': '알 수 없는 오류',

  // ── Register ─────────────────────────────────────────────
  'register.commander_name': '사령관 이름',
  'register.username_placeholder': 'CaptainNova',
  'register.email_address': '이메일 주소',
  'register.password': '비밀번호',
  'register.confirm_password': '비밀번호 확인',
  'register.create_commander': '사령관 생성',
  'register.creating': '생성 중...',
  'register.back_to_login': '< 로그인으로 돌아가기',
  'register.strength_length': '\u2298 8자 이상',
  'register.strength_number': '\u2298 숫자 포함',
  'register.strength_symbol': '\u2298 특수문자 포함',
  'register.passwords_match': '\u2713 비밀번호 일치',
  'register.passwords_no_match': '\u2717 비밀번호 불일치',
  'register.fill_all_fields': '모든 항목을 입력하세요',
  'register.name_too_short': '사령관 이름은 3자 이상이어야 합니다',
  'register.password_too_short': '비밀번호는 8자 이상이어야 합니다',
  'register.passwords_mismatch': '비밀번호가 일치하지 않습니다',
  'register.account_created_login': '계정이 생성되었습니다! 로그인 중...',
  'register.account_created_connect': '계정이 생성되었습니다! 연결 중...',
  'register.connection_failed': '계정은 생성되었지만 게임 연결이 시간 초과되었습니다. 페이지를 새로 고치거나 다시 로그인하세요.',
  'register.registration_failed': '가입 실패',

  // ── HUD Top Bar ──────────────────────────────────────────
  'hud.logo': 'CRIMSON\nMANDATE',
  'hud.menu': '\u2630 메뉴',

  // ── Nav Buttons ──────────────────────────────────────────
  'nav.wreck': '잔해',
  'nav.insure': '보험',
  'nav.trade': '교역',
  'nav.ore': '광석',
  'nav.crew': '승무원',
  'nav.parts': '부품',
  'nav.shop': '상점',
  'nav.buy_isd': 'ISD 구매',
  'nav.station': '기지',
  'nav.center': '중앙',
  'nav.follow': '추적',
  'nav.research': '연구',
  'nav.tech': '기술',
  'nav.alliance_hq': '동맹 본부',
  'nav.refund': '바이백',
  'nav.withdraw': '출금',
  'nav.how_to': '공략',

  // ── Disconnect Overlay ───────────────────────────────────
  'disconnect.title': '연결 끊김',
  'disconnect.idle': '비활동으로 인해 연결이 끊어졌습니다.',
  'disconnect.reconnecting': '재연결 중... ({attempt}/{max})',
  'disconnect.failed': '재연결 실패.',
  'disconnect.reconnect': '재연결',

  // ── Dialog Titles ────────────────────────────────────────
  'dialog.menu': '메뉴',
  'dialog.ship_store': '함선 상점',
  'dialog.components': '부품',
  'dialog.ore_inventory': '광석 보관함',
  'dialog.wreckage': '잔해',
  'dialog.insurance': '보험',
  'dialog.stations': '기지',
  'dialog.crew_quarters': '승무원 구역',
  'dialog.trade_hub': '교역소',
  'dialog.browse_alliances': '동맹 검색',
  'dialog.alliance_hq': '동맹 본부',
  'dialog.commander_profile': '사령관 프로필',
  'dialog.refund': '바이백',
  'dialog.relic_inventory': '유물 보관함',
  'dialog.tech_database': '기술 데이터베이스',
  'dialog.buy_isd': '$ISD 구매',
  'dialog.ship_modification': '함선 개조',
  'dialog.while_away': '부재 중 발생한 일',
  'dialog.research_board': '공개 연구 게시판',
  'dialog.component_enhancement': '부품 강화',
  'dialog.alliance': '동맹',
  'dialog.create_alliance': '동맹 창설',
  'dialog.alliance_management': '동맹 관리',
  'dialog.direct_messages': '개인 메시지',
  'dialog.battle_report': '전투 보고서',
  'dialog.build_ship': '함선 건조 \u2014 {planetName}',
  'dialog.pirate_faction': '해적 세력',
  'dialog.player_profile': '플레이어 프로필',
  'dialog.ship_details': '함선 상세정보',
  'dialog.component_loadout': '부품 장착',
  'dialog.repair_component': '부품 수리',
  'dialog.how_to': '플레이 방법',

  // ── Resource Display ─────────────────────────────────────
  'resource.title': '자원',
  'resource.credits': 'ISD',
  'resource.minerals': '광물',
  'resource.rare_metals': '희귀 금속',
  'resource.tech_data': '기술 데이터',
  'resource.salvage': '인양품',
  'resource.exotic_matter': '이색 물질',

  // ── Left Sidebar ─────────────────────────────────────────
  'sidebar.empire_status': '제국 현황',
  'sidebar.stations': '기지',
  'sidebar.ships': '함선',
  'sidebar.explored': '탐사 완료',
  'sidebar.explored_hexes': '{count} 헥스',
  'sidebar.credit': '크레딧',
  'sidebar.fleet': '함대',
  'sidebar.missions': '임무',
  'sidebar.no_ships': '배치된 함선 없음',
  'sidebar.no_stations': '배치된 기지 없음',
  'sidebar.planet': '행성',
  'sidebar.station_label': '스테이션',
  'sidebar.docked': '도킹됨',
  'sidebar.docked_at': '\u2693 {location}',
  'sidebar.moving': '이동 중 ({turns}턴)',
  'sidebar.hp_percent': 'HP {pct}%',
  'sidebar.cargo': '화물 {used}/{cap}',
  'sidebar.no_missions': '가능한 임무\n없음',
  'sidebar.coming_soon': '준비 중',

  // ── Right Panel (Alliance) ───────────────────────────────
  'alliance.title': '동맹',
  'alliance.members': '{count}명',
  'alliance.online': '{count}명 접속 중',
  'alliance.view': '보기',
  'alliance.message': '메시지',
  'alliance.create': '창설',
  'alliance.browse': '검색',

  // ── Chat Panel ───────────────────────────────────────────
  'chat.tab_chat': '채팅',
  'chat.tab_log': '로그',
  'chat.channel_alliance': '동맹',
  'chat.channel_global': '전체',
  'chat.placeholder': '메시지를 입력하세요...',
  'chat.me': '나',
  'chat.title': '통신',
  'chat.no_messages': '메시지가 없습니다.\n아래에 입력하여 채팅을 시작하세요.',
  'chat.log_initialized': '활동 로그가 초기화되었습니다',

  // ── Command Dock ─────────────────────────────────────────
  // Action buttons
  'action.move': '이동',
  'action.attack': 'ENGAGE',
  'action.dock': '정박',
  'action.undock': '출항',
  'action.mine': '채굴',
  'action.stop': '정지',
  'action.repair': '수리',
  'action.modify': '개조',
  'action.goto': '좌표이동',
  'action.return': '귀환',
  'action.cancel': '취소',
  'action.rename': '이름 변경',
  'action.paint': '도장',
  'action.sensor_boost': '센서 강화',
  'action.warp': '워프',
  'action.beacon': '비콘',
  'action.deliver': '우선 배송',
  'action.pick_color': '색상 선택',
  'action.select_ship_attack': '공격할 함선 선택',
  'action.select_ship_move': '이동할 함선 선택',

  // Action tooltips
  'tooltip.move': '함선을 지정 헥스로 이동',
  'tooltip.attack': '적 함선을 공격',
  'tooltip.dock': '행성 또는 기지에 정박',
  'tooltip.undock': '현재 위치에서 출항',
  'tooltip.mine': '소행성에서 광물 채굴',
  'tooltip.stop_mine': '채굴 중지',
  'tooltip.repair': '화물 광물을 사용하여 선체 수리',
  'tooltip.repair_full': '유닛의 체력이 최대입니다',
  'tooltip.modify': '조선소에서 함선 부품 개조',
  'tooltip.modify_dock': '함선을 개조하려면 기지에 정박하세요',
  'tooltip.goto': '특정 좌표로 항해',
  'tooltip.return_to_base': '가장 가까운 아군 기지로 귀환하여 자동 정박',
  'tooltip.mine_minerals': '광물 채굴...',
  'tooltip.mine_stellar': '골드 채굴...',
  'tooltip.mine_move_adjacent': '채굴하려면 소행성 인접 헥스로 이동하세요',
  'tooltip.dock_no_target': '정박하려면 행성 또는 기지 1헥스 이내로 이동하세요',
  'tooltip.dock_no_range': '정박 가능 범위 내에 행성이나 기지가 없습니다',
  'tooltip.dock_disabled': '여기에 도킹할 수 없습니다',
  'tooltip.undock_move': '도킹 해제 후 이동',
  'tooltip.repair_hull': '선체 수리',
  'tooltip.full_health': '만충',
  'tooltip.modify_components': '부품 변경',
  'tooltip.dock_to_modify': '도킹 후 변경 가능',
  'tooltip.speed': '속도',
  'tooltip.attack_stat': '공격력',
  'tooltip.defense': '방어력',
  'tooltip.range': '사정거리',
  'tooltip.hull_integrity': '선체 완전성',
  'tooltip.shields_desc': '실드 설명',
  'tooltip.sensor_sweep': '센서 스캔',
  'tooltip.evasive_maneuvers': '회피 기동',
  'tooltip.afterburner': '애프터버너',
  'tooltip.missile_barrage': '미사일 일제 사격',
  'tooltip.broadside': '현측 일제 사격',
  'tooltip.shield_overcharge': '실드 과충전',
  'tooltip.emergency_jump': '긴급 점프',
  'tooltip.richness': '풍부도',
  'tooltip.remaining_ore': '잔여 광석',
  'tooltip.rarity': '희귀도',
  'tooltip.asteroid_stellar': '암호화폐 포함',
  'tooltip.asteroid_no_stellar': '암호화폐 없음',
  'tooltip.planet_structural': '행성 구조 완전성',
  'tooltip.station_structural': '스테이션 구조 완전성',
  'tooltip.mineral_storage': '광물 저장소',
  'tooltip.docked_planet': '행성에 도킹 중',
  'tooltip.docked_station': '스테이션에 도킹 중',
  'tooltip.fee_earth': '지구 수수료',
  'tooltip.fee_station': '스테이션 수수료',
  'tooltip.planet_status': '행성 상태',
  'tooltip.station_status': '스테이션 상태',

  // Stat labels
  'stat.health': '체력',
  'stat.shields': '방어막',
  'stat.speed': '속도',
  'stat.attack': '공격력',
  'stat.defense': '방어력',
  'stat.range': '사거리',
  'stat.storage': '적재량',
  'stat.docked': '도킹됨',
  'stat.fee': '수수료',
  'stat.status': '상태',
  'stat.active': '활성',
  'storage.label': '저장소',

  // Stat tooltips
  'stat_tip.health': '현재 선체 내구도',
  'stat_tip.shields': '에너지 방어막 강도',
  'stat_tip.movement': '턴당 이동 가능 헥스',
  'stat_tip.attack': '무기 피해량',
  'stat_tip.defense': '피해 감소량',
  'stat_tip.range': '최대 무기 사거리',

  // Abilities
  'ability.scan': '스캔',
  'ability.evade': '회피',
  'ability.boost': '부스트',
  'ability.volley': '일제사격',
  'ability.broad': '현측포격',
  'ability.shield': '방어막',
  'ability.jump': '워프',
  'ability.none': '능력 없음',

  'ability_tip.scan': '주변 지역 탐색',
  'ability_tip.evade': '회피 기동 모드 돌입',
  'ability_tip.boost': '엔진 출력 증가',
  'ability_tip.volley': '모든 무기 동시 발사',
  'ability_tip.broad': '현측 포격 발사',
  'ability_tip.shield': '방어막 발생기 과충전',
  'ability_tip.jump': '워프 점프 시작',

  // Tabs (ship)
  'tab.actions': '행동',
  'tab.abilities': '능력',
  'tab.cargo': '화물 {used}/{cap}',
  'tab.crew': '승무원',
  'tab.upgrades': '강화',

  // Tabs (planet)
  'tab.storage': '저장소',
  'tab.stellar': '골드',
  'tab.build': '건조',

  // Tabs (station)
  'tab.manage': '관리',

  // Cargo
  'cargo.full_tooltip': '화물칸이 가득 찼습니다! 행성이나 기지에 정박하여 하역하세요.',
  'cargo.loading': '화물 로딩 중...',
  'cargo.empty': '화물칸이 비어 있습니다',

  // Storage
  'storage.loading': '보관함 로딩 중...',
  'storage.empty': '보관된 광물 없음',
  'storage.stellar_stored': '골드 보유량',
  'storage.buy_ship': '함선 구매',
  'storage.buy_parts': '부품 구매',
  'storage.buy_crew': '승무원 고용',

  // Asteroid
  'asteroid.richness': '풍부도',
  'asteroid.rarity': '희귀도',
  'asteroid.stellar': '골드',
  'asteroid.composition': '구성 성분',
  'asteroid.remaining_ore': '잔여 광석',
  'asteroid.stellar_label': '암호화폐',
  'asteroid.legendary': '전설',
  'asteroid.very_rich': '매우 풍부',
  'asteroid.rich': '풍부',
  'asteroid.moderate': '보통',
  'asteroid.poor': '빈약',
  'asteroid.no_mineral_data': '광물 데이터 없음',
  'asteroid.suffix': ' 소행성',

  // Richness tiers
  'richness.legendary': '전설급',
  'richness.very_rich': '매우 풍부',
  'richness.rich': '풍부',
  'richness.moderate': '보통',
  'richness.poor': '빈약',

  // Rarity tiers
  'rarity.legendary': '전설',
  'rarity.epic': '영웅',
  'rarity.rare': '희귀',
  'rarity.uncommon': '고급',
  'rarity.common': '일반',

  // Asteroid richness tooltips
  'asteroid_tip.richness': '광물 농축 품질',
  'asteroid_tip.rarity': '이 소행성의 희귀 등급',
  'asteroid_tip.stellar': '지구로 견인 시 골드 수익',

  // Asteroid variant names
  'asteroid_variant.gold': '골드',
  'asteroid_variant.platinum': '플래티넘',
  'asteroid_variant.dark_matter': '암흑 물질',

  // Minerals
  'mineral.iron': '철',
  'mineral.copper': '구리',
  'mineral.titanium': '티타늄',
  'mineral.platinum': '백금',
  'mineral.rhodium': '로듐',
  'mineral.palladium': '팔라듐',
  'mineral.iridium': '이리듐',
  'mineral.dark_matter': '암흑 물질',
  'mineral.rare': '레어',
  'mineral.common': '일반',
  'mineral.epic': '에픽',
  'mineral.uncommon': '언커먼',

  // Wreck
  'wreck.repair': '수리',
  'wreck.suffix': ' 잔해',
  'wreck.time_left': '남은 시간 (시)',
  'wreck.type': '유형',
  'wreck.tow': '견인',
  'wreck.repair_label': '수리',
  'wreck.your_wreck': '내 잔해',
  'wreck.manage': '관리',
  'wreck.being_towed': '견인 중',
  'wreck.being_repaired': '수리 중',
  'wreck.claimed': '확보됨',
  'wreck.claim': '확보',

  // Enemy / Unit
  'unit.you': '(본인)',
  'unit.enemy': '적',
  'unit.loading': '로딩 중...',
  'unit.no_ships': '보유 함선이 없습니다',
  'unit.select_attack': '공격할 함선을 선택하세요',
  'unit.select_move': '이동할 함선을 선택하세요',

  'enemy.badge': '적',

  // Enemy actions
  'enemy.player': '플레이어',
  'enemy.ship': '함선',
  'enemy.message': '메시지',
  'enemy.move_to': '이동',

  // Planet
  'planet.home': '\u2605 모성',
  'planet.neutral': '중립',
  'planet.your_planet': '내 행성',
  'planet.docked': '정박 중',
  'planet.fee': '수수료',
  'planet.status': '상태',
  'planet.active': '활성',
  'planet.nothing_producing': '생산 중인 항목 없음',
  'planet.no_production': '생산 없음',
  'planet.done': '완료',
  'planet.in_progress': '진행 중',
  'planet.more_queued': '+{n}개 대기 중',
  'planet.produce_ship': '함선 생산',
  'planet.produce_ship_tooltip': '이 행성에서 새 함선 건조',

  // Station
  'station.waypoint': '중계소',
  'station.depot': '보급소',
  'station.fortress': '요새',
  'station.capital': '수도',
  'station.your_station': '내 기지',
  'station.stored_asteroids': '보관 중인 소행성',
  'station.docking_fee': '정박 수수료',
  'station.manage_station': '기지 관리',
  'station.manage_tooltip': '기지 관리 패널 열기',
  'station.produce_tooltip': '이 기지에서 새 함선 건조',
  'station.enemy': '적',
  'station.nothing_producing': '생산 중인 것 없음',
  'station.no_production': '생산 없음',
  'station.done': '완료',
  'station.in_progress': '진행 중',
  'station.produce_ship': '함선 생산',

  // Upgrades / Burn sinks
  'upgrade.rename': '이름 변경',
  'upgrade.rename_prompt': '새 함선 이름을 입력하세요 (최대 20자):',
  'upgrade.rename_tooltip': '함선에 고유 이름 부여 (100 ISD)',
  'upgrade.paint': '도색',
  'upgrade.paint_tooltip': '함선 색상 변경 (100 ISD)',
  'upgrade.sensor': '센서+',
  'upgrade.sensor_tooltip': '센서 범위 1헥스 확장 (500 ISD)',
  'upgrade.warp': '워프',
  'upgrade.warp_soon': '워프 점프: 헥스 선택 기능 준비 중',
  'upgrade.warp_tooltip': '워프 점프 능력 해제 (2000 ISD)',
  'upgrade.beacon': '비콘',
  'upgrade.beacon_no_alliance': '비콘을 배치하려면 동맹에 가입해야 합니다',
  'upgrade.beacon_tooltip': '현재 위치에 함대 비콘 배치 (200 ISD)',
  'upgrade.deliver': '우선',
  'upgrade.deliver_tooltip': '견인 우선 배송 지정 (300 ISD)',
  'upgrade.pick_color': '색상 선택',

  // Paint colors
  'color.red': '빨강',
  'color.green': '초록',
  'color.blue': '파랑',
  'color.yellow': '노랑',
  'color.pink': '분홍',
  'color.cyan': '하늘',
  'color.orange': '주황',
  'color.white': '흰색',

  // GOTO popup
  'goto.q': 'Q',
  'goto.r': 'R',
  'goto.go': '이동',

  // Ship types
  'ship.scout': '정찰선',
  'ship.fighter': '전투기',
  'ship.destroyer': '구축함',
  'ship.bomber': '폭격기',
  'ship.trade_ship': '수송선',
  'ship.cruiser': '순양함',
  'ship.carrier': '항공모함',
  'ship.battleship': '전함',
  'ship.dreadnought': '드레드노트',
  'ship.titan': '타이탄',
  'ship.space_tug': '우주 예인선',
  'ship.alien_leviathan': '외계 리바이어던',

  // Ship roles
  'role.recon': '정찰',
  'role.light_combat': '경전투',
  'role.strike': '타격',
  'role.heavy_strike': '중타격',
  'role.logistics': '보급',
  'role.heavy_combat': '중전투',
  'role.fleet_support': '함대 지원',
  'role.assault': '강습',
  'role.capital': '기함급',
  'role.flagship': '기함',

  // Ship store
  'store.buy_ship': '함선 구매',
  'store.buy_parts': '부품 구매',
  'store.buy_crew': '승무원 고용',
  'store.credits': 'ISD: {n}',
  'store.loading_prices': '함선 가격 로딩 중...',
  'store.load_failed': '가격 로딩 실패. 나중에 다시 시도하세요.',

  // Component categories
  'comp.all': '전체',
  'comp.weap': '무기',
  'comp.eng': '엔진',
  'comp.shld': '방어막',
  'comp.armr': '장갑',
  'comp.snsr': '센서',
  'comp.rctr': '반응로',
  'comp.spec': '특수',

  // Component tiers
  'tier.mk1': 'Mk I',
  'tier.mk2': 'Mk II',
  'tier.mk3': 'Mk III',
  'tier.mk4': 'Mk IV',
  'tier.proto': '프로토',
  'tier.basic': '기본',
  'tier.improved': '개량',
  'tier.advanced': '고급',
  'tier.elite': '정예',
  'tier.experimental': '실험용',

  // Component stats
  'comp_stat.hull_hp': '선체 HP',
  'comp_stat.shields': '방어막',
  'comp_stat.armor': '장갑',
  'comp_stat.speed': '속도',
  'comp_stat.evasion': '회피율',
  'comp_stat.sensor_range': '센서 범위',
  'comp_stat.accuracy': '명중률',
  'comp_stat.attack': '공격력',
  'comp_stat.defense': '방어력',
  'comp_stat.power_output': '출력',
  'comp_stat.cooldown_reduc': '쿨타임 감소',
  'comp_stat.shield_regen': '방어막 재생',
  'comp_stat.damage': '피해량',
  'comp_stat.fire_rate': '연사 속도',

  // Hamburger menu
  'hamburger.audio': '오디오',
  'hamburger.master': '마스터',
  'hamburger.music': '음악',

  // Tutorial hint panel
  'tutorial.dismiss': 'X',
  'tutorial.skip': '건너뛰기',

  // Number formatting
  'format.millions': 'M',
  'format.thousands': 'K',

  // FTUE hints (from server, but client can also use for display)
  'ftue.brand_new': '환영합니다, 사령관! 정찰선을 클릭하여 선택하세요.',
  'ftue.first_select': '좋습니다! 이제 인근 헥스를 우클릭하여 정찰선을 이동하세요.',
  'ftue.first_move': '이동 중입니다! 맵을 탐험하세요 \u2014 어두운 헥스는 미탐사 지역입니다.',
  'ftue.explore_vision': '소행성을 찾아 채굴 버튼을 눌러 광물을 수집하세요.',
  'ftue.first_mine': '훌륭한 채굴입니다! 지구에 정박하여 화물을 하역하세요.',
  'ftue.first_dock': '함선 상점을 열어 구매 가능한 함선을 확인해 보세요.',
  'ftue.understand_hud': '상단 바 버튼으로 함선 구매, 교역 등을 할 수 있습니다!',
  'ftue.first_purchase': '별들을 정복할 준비가 되었습니다! 튜토리얼 완료.',

  // Welcome asteroid
  'ftue.welcome_asteroid': '환영 선물 소행성이 근처에 나타났습니다! 채굴하여 보상을 받으세요.',
  'asteroid.welcome_gift': '환영 선물',
  'notification.welcome_claimed': '환영 보상을 받았습니다!',

  // ── Mineral Inventory Dialog ──────────────────────────────
  'ore.browse_trade': '거래소 보기',
  'ore.total_mined': '총 채굴량',
  'ore.base_value': '기본 가치',
  'ore.market_data': '시장 데이터',
  'ore.lowest': '최저',
  'ore.average': '평균',
  'ore.highest': '최고',
  'ore.active_listings': '활성 매물',
  'ore.no_listings': '매물 없음',
  'ore.sell': '판매',
  'ore.select_location': '위치를 선택하여 광물 보기',
  'ore.total_minerals': '광물 합계',
  'ore.mineral_types': '광물 종류',
  'ore.stored_minerals': '저장된 광물',
  'ore.est_value': '예상 가치(기본)',
  'ore.in_inventory': '보유 중',
  'ore.tab_all': '전체',
  'ore.tab_by_location': '위치별',

  // ── Alliance HQ Dialog ────────────────────────────────────
  'alliance_hq.outpost': '전초기지',
  'alliance_hq.station': '스테이션',
  'alliance_hq.fortress': '요새',
  'alliance_hq.citadel': '성채',
  'alliance_hq.equal_split': '균등 분배',
  'alliance_hq.rank_weighted': '등급 가중',
  'alliance_hq.activity_weighted': '활동 가중',
  'alliance_hq.custom': '맞춤형',

  // ── Station Management Dialog ─────────────────────────────
  'station_mgmt.basic_desc': '기본 보급소. 낮은 저장량, 낮은 비용.',
  'station_mgmt.mid_desc': '중급 물류 허브. 확장된 저장 용량.',
  'station_mgmt.fort_desc': '중무장 전초기지. 강력한 방어력.',
  'station_mgmt.capital_desc': '대형 사령부. 최대 저장 및 배치 능력.',
  'station_mgmt.hp': 'HP',
  'station_mgmt.storage': '저장',
  'station_mgmt.owned_stations': '소유 스테이션',
  'station_mgmt.no_stations': '스테이션 미보유',
  'station_mgmt.get_started': '위 스테이션을 구매하여 시작',

  // ── Wreckage Dialog — time formatting ────────────────────
  'time.days': '일',
  'time.hours': '시',
  'time.minutes': '분',
  'time.expired': '만료됨',

  // Crew tab
  'crew.loading': '승무원 불러오는 중...',
  'crew.none_assigned': '배정된 승무원 없음',
  'crew.skill_combat': '전투',
  'crew.skill_piloting': '조종',
  'crew.skill_navigation': '항해',
  'crew.skill_engineering': '공학',
  'crew.skill_science': '과학',

  // ── How To Guide ──────────────────────────────────────────
  'howto.title': '플레이 방법',
  'howto.skip': '건너뛰기',
  'howto.next': '다음',
  'howto.back': '이전',
  'howto.done': '완료',
  'howto.launch': '시작 ▶',
  'howto.page1_title': '환영합니다, 사령관',
  'howto.page1_bullet1': '당신의 함대, 당신의 영토. 모든 행동이 흔적을 남기는 영속적인 은하.',
  'howto.page1_bullet2': '전함, 채굴선, 정찰선을 건조하세요. 별들 사이에서 영토를 주장하세요.',
  'howto.page2_title': '미지를 탐험하라',
  'howto.page2_bullet1': '헥스로 이동하여 탐험. 센서가 근처 우주를 밝히고, 나머지는 어둠.',
  'howto.page2_bullet2': '지구 근처가 안전합니다. 멀어질수록 풍요롭지만 위험합니다.',
  'howto.page3_title': '제국을 건설하라',
  'howto.page3_bullet1': '소행성을 채굴하여 자원 획득 — 철, 백금, 심지어 암흑 물질까지.',
  'howto.page3_bullet2': '스테이션에 도킹하여 하역, 수리, 함대 업그레이드.',
  'howto.page4_title': '빼앗아라',
  'howto.page4_bullet1': '라이벌을 공격하고, 잔해를 인양하고, 전리품을 차지하세요.',
  'howto.page4_bullet2': '적 스테이션을 습격하고 무역로를 장악하세요.',
  'howto.page5_title': '자유롭게 플레이',
  'howto.page5_bullet1': '동맹에 가입하여 연구, 영토, 힘을 공유하거나 — 홀로 행동하세요.',
  'howto.page5_bullet2': '채굴자, 해적, 재벌, 함대 사령관으로 솔로 플레이. 당신의 선택.',
  'howto.page6_title': '미지가 기다린다',
  'howto.page6_bullet1': '심우주에서 외계 유물, 크립토이드, 리바이어선을 발견하세요.',
  'howto.page6_bullet2': '은하는 광대합니다. 어떻게 정복할지는 당신에게 달렸습니다.',

  // ── Platforms ────────────────────────────────────────────
  'platform.basic': '기본 플랫폼',
  'platform.advanced': '고급 플랫폼',
  'platform.elite': '엘리트 플랫폼',
  'platform.legendary': '전설 플랫폼',
  'platform.deploy': '플랫폼 배치',
  'platform.relocate': '플랫폼 재배치',
  'platform.manage': '플랫폼 관리',
  'platform.purchase': '플랫폼 구매',
  'platform.mining_yield': '궤도 채굴 산출량',
  'platform.storage': '플랫폼 저장소',
  'platform.capabilities': '능력',
  'platform.dock': '도킹 베이',
  'platform.repair': '수리 베이',
  'platform.shipyard': '조선소',
  'platform.build': '유닛 건조',
  'platform.mining': '궤도 채굴',
  'platform.earth_station': '지구 궤도 스테이션',
  'platform.public': '공공 플랫폼',
  'planet.resources': '행성 자원',
  'planet.depleted': '고갈됨',
  'planet.remaining': '잔여',
  'commanddock.dock_platform': '플랫폼에 도킹',

  // ── Leaderboard ────────────────────────────────────────────
  'nav.leaderboard': '리더보드',
  'dialog.leaderboard': '동맹 리더보드',
  'leaderboard.rank': '순위',
  'leaderboard.alliance': '동맹',
  'leaderboard.prestige': '명성',
  'leaderboard.territory': '영토',
  'leaderboard.members': '멤버',
  'leaderboard.hq_tier': '본부 등급',
  'leaderboard.no_data': '동맹 데이터가 없습니다.',
  'leaderboard.refresh': '새로고침',
};
